var exports = {
  "i": "x8b4e8595--36ac47--favorite-button",
  "v": "x8b4e8595--36ac47--active",
};

module.exports = exports;
